// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dropdown-trigger.a.dropdown-item.is-active[data-v-5241bfac] {\n  background-color: #4BB543;\n}\n.button-gap[data-v-5241bfac] {\n  margin-top: 10px;\n}\n.button-location-gap[data-v-5241bfac] {\n  margin-left: 10px;\n  margin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
